export class ArrayNotContainsValueBaseValueConverter {
    toView(array, value) {
        return array.indexOf(value) < 0
    }
}